export default "__VITE_ASSET__aae7617e__"